import * as Api from '../../../extViewmodels';
import { ISelectBoxOption } from '../../../web/components/SelectBox';

const NoneOption: ISelectBoxOption<null> = { title: 'None', value: null };

export const getBrokerDealerOptions = (industry: Api.Industry): ISelectBoxOption<Api.BrokerDealer | null>[] | null => {
	if (industry === Api.Industry.HomeMaintenance) {
		return [
			NoneOption,
			...Api.AllHomeMaintenanceBrokerDealers.map(brokerDealer => {
				return {
					title: brokerDealer,
					value: brokerDealer as Api.BrokerDealer | null,
				};
			}),
		];
	} else if (industry === Api.Industry.Financial) {
		return [
			NoneOption,
			...Api.AllFinancialBrokerDealers.map(brokerDealer => {
				return {
					title: brokerDealer,
					value: brokerDealer as Api.BrokerDealer | null,
				};
			}),
		];
	} else if (industry === Api.Industry.NonProfit) {
		return [
			NoneOption,
			...Api.AllNonProfitBrokerDealers.map(brokerDealer => {
				return {
					title: brokerDealer,
					value: brokerDealer as Api.BrokerDealer | null,
				};
			}),
		];
	}
	return null;
};
